import { listMethod, retrieveMethod } from "./resource";
const resource = "autocomplete/addresses";
export const list = (client, request) => listMethod({ resource, client })(request);
// Resolves address to the GBR format
export const usa = (client, id, request) => retrieveMethod({
    resource,
    client,
    action: "usa",
})(id, request);
// Resolves address to the GBR format
export const gbr = (client, id, request) => retrieveMethod({
    resource,
    client,
    action: "gbr",
})(id, request);
